import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FilterList, Post } from "../utils/api";

const Filter = ({onFilter}) => {
    const [filterData,setFilterData] = useState({});
    const [filterList,setfilterList] = useState([]);
    const [filterLoading,setfilterLoading] = useState(false);
    const {userinfo} = useSelector(state=>state);
    useEffect(()=>{
        fetchFilterList();
    },[]);

    const fetchFilterList = () =>{
        setfilterLoading(true)
        let config = {
            body:{
                user_id:userinfo?.data?.id,
            },
            url:FilterList,
        }
        Post(config).then((res)=>{
            setfilterLoading(false)
            if(res.success == true) {
                setfilterList(res.categories);
            }
        }).catch((err)=>{
            setfilterLoading(false)
            console.log(err?.response?.data);
        })
    }

    const changeFilterData = (d1,d2) =>{
        d1 = d1?.toLowerCase();
        d2 = d2?.toLowerCase();
        let data = {...filterData};
        if(data[d1]) {
            let newData = [...data[d1]];
            let findindex = newData.indexOf(d2);
            if(findindex != -1) {
                newData?.splice(findindex,1);
            } else {
                newData = [...newData,d2];
            }
            data[d1] = newData;
        } else {
            data[d1] = [d2]
        }
        setFilterData(data);
        onFilter(data);
    }

    return (
        <div
            style={{ marginTop: '50px', marginBottom: '50px' ,width : "12%",marginLeft : "5%"}}>
            <div className="filter">
                <h3>Filters</h3>
                {(filterLoading)&&
                    <div style={{
                        display: 'flex',
                        height: '300px',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}>
                        <img src={'/images/loader.gif'} style={{height:100,width:100}} />
                    </div>
                }
                {filterList?.map((v,i)=>(
                    <div className="filters">
                        <div className="line1">
                            <p>{v.category_name}</p>
                        </div>
                        <div className="radio">
                            {v.data?.map((v2,i2)=>(
                                <div className="form-check">
                                    <input onClick={()=>{
                                        changeFilterData(v.category_name,v2.value);
                                    }} value={v2.value} className="form-check-input" type="checkbox" name="flexRadioDefault"
                                        id="flexRadioDefault1" />
                                    <label className="form-check-label" for="flexRadioDefault1">
                                        {v2.variant}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Filter;